module.exports = __webpack_public_path__ + "static/img/produto_p.a3e1372.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/citrus/produto_p.png
// module id = +CM4
// module chunks = 0